import { useState, useEffect, useMemo } from "react"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import DataTable from "examples/Tables/DataTable"
import AddIcon from "@mui/icons-material/Add"
import { Stack } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import PreviewIcon from "@mui/icons-material/Preview"
import DoneIcon from "@mui/icons-material/Done"
import EditIcon from "@mui/icons-material/Edit"
import { ToastContainer, toast } from "react-toastify"
import "../campus/Campus.css"
import { Typography } from "@mui/material"
const BASE_URL = process.env.REACT_APP_BASE_URL
const token = sessionStorage.getItem("token")
import CircularProgress from "@mui/material/CircularProgress"
import DeleteIcon from "@mui/icons-material/Delete"
import PolicyIcon from "@mui/icons-material/Policy"
import Tooltip from "@mui/material/Tooltip"
import Select from "react-select"
import nodata from "assets/images/nodata.png"
import { hasAdmissionPermission } from "hooks/permissions"
import VoucherDialog from "../student_dashboard/Pages/VoucherDialog"
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import RadioGroup from "@mui/material/RadioGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import Radio from "@mui/material/Radio"
import SendIcon from '@mui/icons-material/Send';
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import html2pdf from "html2pdf.js"

const MeritListV2 = () => {
  const [selectedCampaign, setSelectedCampaign] = useState("")
  const [campaigns, setCampaigns] = useState([])
  const [selectedDepartment, setSelectedDepartment] = useState("")
  const [departments, setDepartments] = useState([])
  const [programs, setPrograms] = useState([])
  const [selectedProgram, setSelectedProgram] = useState("")
  const [quotas, setQuotas] = useState([])
  const [selectedQuota, setSelectedQuota] = useState("")
  const [meritLists, setMeritLists] = useState([])
  const [openDialog, setOpenDialog] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [openViewDialog, setOpenViewDialog] = useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)

  // Add new state for want to include field
  const [wantToInclude, setWantToInclude] = useState("both")

  // Add new state for merit list application deletion
  const [openDeleteApplicationDialog, setOpenDeleteApplicationDialog] = useState(false)
  const [currentApplicationId, setCurrentApplicationId] = useState("")
  const [currentApplicationName, setCurrentApplicationName] = useState("")
  const [deleteApplicationLoading, setDeleteApplicationLoading] = useState(false)

  // Add new state for update dialog
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false)
  const [updateName, setUpdateName] = useState("")
  const [updateLastDate, setUpdateLastDate] = useState("")
  const [updateMeritListId, setUpdateMeritListId] = useState("")
  const [updateErrors, setUpdateErrors] = useState({})
  const [updateLoading, setUpdateLoading] = useState(false)

  // Add new state for program adjustment dialog
  const [openProgramAdjustDialog, setOpenProgramAdjustDialog] = useState(false)
  const [adjustmentPrograms, setAdjustmentPrograms] = useState([])
  const [adjustmentQuotas, setAdjustmentQuotas] = useState([])
  const [selectedAdjustmentProgram, setSelectedAdjustmentProgram] = useState("")
  const [selectedAdjustmentQuota, setSelectedAdjustmentQuota] = useState("")
  const [currentMeritApplicationId, setCurrentMeritApplicationId] = useState("")
  const [currentMeritListId, setCurrentMeritListId] = useState("")
  const [adjustmentLoading, setAdjustmentLoading] = useState(false)
  const [adjustmentErrors, setAdjustmentErrors] = useState({})
  const [canAdjustMorning, setCanAdjustMorning] = useState(false)

  const [generatedMeritList, setGeneratedMeritList] = useState([])
  const [academics, setAcademics] = useState([])
  const [academicErrors, setAcademicErrors] = useState([])
  const [previousPrograms, setPreviousPrograms] = useState([])
  const [universities, setUniversities] = useState([])
  const [subjects, setSubjects] = useState([])
  const [loading, setLoading] = useState(false)
  const [verifyLoading, setVerifyLoading] = useState(false)
  const [name, setName] = useState("")
  const [lastDate, setLastDate] = useState("")
  const [currentId, setCurrentId] = useState("")
  const [errors, setErrors] = useState({})
  const [meritListApplications, setMeritListApplications] = useState([])
  const [meritListApplication, setMeritListApplication] = useState("")
  const [applicationForm, setApplicationForm] = useState("")
  const [meritList, setMeritList] = useState("")
  const [meritListTypes, setMeritListTypes] = useState([])
  const [selectedMeritListType, setSelectedMeritListType] = useState("")
  const [programCriteriaId, setProgramCriteriaId] = useState("")
  const [merit_lists_templates, setMeritListsTemplates] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState("")
  const [multiplier, setMultiplier] = useState(1)
  const [searchQuery, setSearchQuery] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalItems, setTotalItems] = useState(0)
  const [hasNext, setHasNext] = useState(false)
  const [hasPrevious, setHasPrevious] = useState(false)
  const [paginationLoading, setPaginationLoading] = useState(false)
  const [admissionVoucher, setAdmissionVoucher] = useState({})
  const [voucherModal, setVoucherModal] = useState(false)
  const [groupedDegrees, setGroupedDegrees] = useState([])

  // Add loading states for various operations
  const [campaignsLoading, setCampaignsLoading] = useState(false)
  const [departmentsLoading, setDepartmentsLoading] = useState(false)
  const [programsLoading, setProgramsLoading] = useState(false)
  const [quotasLoading, setQuotasLoading] = useState(false)
  const [meritListsLoading, setMeritListsLoading] = useState(false)
  const [saveLoading, setSaveLoading] = useState(false)
  const [approveLoading, setApproveLoading] = useState(false)
  const [whatsappLoading, setWhatsappLoading] = useState(false)
  const [voucherLoading, setVoucherLoading] = useState(false)

  // Add new loading state for view applications
  const [viewApplicationsLoading, setViewApplicationsLoading] = useState(false)
  const [currentViewingMeritId, setCurrentViewingMeritId] = useState("")
  const [currentMeritUrlToken, setCurrentMeritUrlToken] = useState("")
  const [currentViewingMeritName, setCurrentViewingMeritName] = useState("")
  const [exportPdfLoading, setExportPdfLoading] = useState(false)

  const handleCloseVoucherModal = () => {
    setVoucherModal(false)
  }

  const handleOpenDialog = () => {
    // Reset form when opening dialog
    setName("")
    setLastDate("")
    setSelectedCampaign("")
    setSelectedDepartment("")
    setSelectedProgram("")
    setSelectedQuota("")
    setSelectedMeritListType("")
    setSelectedTemplate("")
    setMultiplier(1)
    setWantToInclude("both") // Reset to default
    setGeneratedMeritList([])
    setErrors({})
    setOpenDialog(true)
  }

  const handleOpenDeleteDialog = () => {
    setOpenDeleteDialog(true)
  }

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false)
  }

  const handleOpenViewDialog = () => {
    setOpenViewDialog(true)
  }

  const handleCloseViewDialog = () => {
  setOpenViewDialog(false)
  setSearchQuery("")
  setCurrentPage(1)
  setMeritListApplications([])
  setCurrentMeritListId(null)
  setCurrentMeritUrlToken("")
  setCurrentViewingMeritName("")
}

  const handleExportMeritListPdf = async () => {
    if (!currentMeritListId) {
      toast.error("No merit list selected")
      return
    }

    setExportPdfLoading(true)
    try {
      const allApplications = []
      let page = 1
      let totalPagesToFetch = 1
      const search = debouncedSearchQuery || ""

      do {
        const params = new URLSearchParams({ page: page.toString() })
        if (search.trim() !== "") {
          params.append("search", search.trim())
        }

        const response = await fetch(
          `${BASE_URL}/application/get_merit_list_applications/${currentMeritListId}?${params}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )

        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.error || "Failed to fetch applications")
        }

        allApplications.push(...(data.merit_list_applications || []))
        totalPagesToFetch = data.pagination?.total_pages || 1
        page += 1
      } while (page <= totalPagesToFetch)

      if (allApplications.length === 0) {
        toast.error("No applications to export")
        return
      }

      const meritName =
        currentViewingMeritName ||
        meritLists.find((merit) => merit.id === currentMeritListId)?.name ||
        "MeritList"

      const rowsHtml = allApplications
        .map(
          (item, index) => `
          <tr>
            <td>${index + 1}</td>
            <td>${item.application_form || ""}</td>
            <td>${item.first_name || ""}</td>
            <td>${item.cnic || ""}</td>
            <td>${item.applicant_phone || ""}</td>
            <td>${item.father_name || ""}</td>
            <td>${item.aggregrate != null ? Number(item.aggregrate).toFixed(2) : ""}</td>
            <td>${item.is_verified == 1 ? "Verified" : "Not Verified"}</td>
          </tr>`
        )
        .join("")

      const container = document.createElement("div")
      container.innerHTML = `
        <div style="font-family: Arial, sans-serif; padding: 12px; color: #000;">
          <h2 style="text-align: center; margin: 0 0 8px 0;">${meritName}</h2>
          <p style="text-align: center; margin: 0 0 16px 0; font-size: 12px;">
            Merit List Applications (${allApplications.length})
          </p>
          <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
            <thead>
              <tr>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">Sr.No</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">Form No</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">Name</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">CNIC</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">Phone</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">Father Name</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">Aggregate</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">Status</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
        </div>
      `

      const tableCells = container.querySelectorAll("td")
      tableCells.forEach((cell) => {
        cell.style.border = "1px solid #000"
        cell.style.padding = "6px"
        cell.style.textAlign = "center"
      })

      const safeName = meritName
        .replace(/[^\w\s-]/g, "")
        .trim()
        .replace(/\s+/g, "_")

      await html2pdf()
        .set({
          margin: 8,
          filename: `${safeName || "MeritList"}_applications.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
        })
        .from(container)
        .save()
    } catch (error) {
      console.error(error)
      toast.error("Failed to export applications PDF")
    } finally {
      setExportPdfLoading(false)
    }
  }

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false)
  }

  // Add new handlers for merit list application deletion
  const handleOpenDeleteApplicationDialog = (applicationId, applicationName) => {
    setCurrentApplicationId(applicationId)
    setCurrentApplicationName(applicationName)
    setOpenDeleteApplicationDialog(true)
  }

  const handleCloseDeleteApplicationDialog = () => {
    setOpenDeleteApplicationDialog(false)
    setCurrentApplicationId("")
    setCurrentApplicationName("")
  }

  const handleDeleteApplication = async () => {
    if (!currentApplicationId) {
      toast.error("No application selected for deletion")
      return
    }

    setDeleteApplicationLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/delete_merit_list_application/${currentApplicationId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()
      if (response.ok) {
        await getMeritListApplications(currentMeritListId)
        toast.success(data.success || "Application deleted successfully")
        // Refresh the merit list applications
        handleCloseDeleteApplicationDialog()
      } else {
        toast.error(data.error || "Failed to delete application")
      }
    } catch (error) {
      console.error("Error deleting application:", error)
      toast.error("Failed to delete application")
    } finally {
      setDeleteApplicationLoading(false)
    }
  }

  // Add new handlers for update dialog
  const handleOpenUpdateDialog = (meritListId, currentName, currentLastDate) => {
    setUpdateMeritListId(meritListId)
    setUpdateName(currentName)
    setUpdateLastDate(currentLastDate)
    setUpdateErrors({})
    setOpenUpdateDialog(true)
  }

  const handleCloseUpdateDialog = () => {
    setOpenUpdateDialog(false)
    setUpdateName("")
    setUpdateLastDate("")
    setUpdateMeritListId("")
    setUpdateErrors({})
  }

  // Add new handlers for program adjustment dialog
  const handleOpenProgramAdjustDialog = async (meritApplicationId, meritListId) => {
    setCurrentMeritApplicationId(meritApplicationId)
    setCurrentMeritListId(meritListId)
    setSelectedAdjustmentProgram("")
    setSelectedAdjustmentQuota("")
    setAdjustmentErrors({})

    try {
      const response = await fetch(`${BASE_URL}/application/get_programs_by_merit_list/${meritListId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()
      if (response.ok) {
        setAdjustmentPrograms(data.programs || [])
        setCanAdjustMorning(Boolean(data.can_adjust_morning))
        setOpenProgramAdjustDialog(true)
      } else {
        toast.error(data.error || "Failed to fetch programs for adjustment")
      }
    } catch (error) {
      console.error("Error fetching programs for adjustment:", error)
      toast.error("Failed to fetch programs for adjustment")
    }
  }

  const handleCloseProgramAdjustDialog = () => {
    setOpenProgramAdjustDialog(false)
    setCurrentMeritApplicationId("")
    setCurrentMeritListId("")
    setSelectedAdjustmentProgram("")
    setSelectedAdjustmentQuota("")
    setAdjustmentErrors({})
    setCanAdjustMorning(false)
  }

  const formatAdjustmentProgramLabel = (program) => {
    const groupLabel = program.group
      ? program.group.charAt(0) + program.group.slice(1).toLowerCase()
      : ""
    return groupLabel ? `${program.name} (${groupLabel})` : program.name
  }

  // Enhanced validation for program adjustment
  const validateProgramAdjustment = () => {
    const errors = {}
    if (!selectedAdjustmentProgram) {
      errors.program = "Program is required"
    }
    return errors
  }

  // Add program adjustment API call
  const handleProgramAdjustment = async () => {
    const errors = validateProgramAdjustment()
    if (Object.keys(errors).length > 0) {
      setAdjustmentErrors(errors)
      return
    }

    setAdjustmentLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/verifyDocumentwithAdjust`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          merit_application_id: currentMeritApplicationId,
          program_id: selectedAdjustmentProgram,
        }),
      })

      if (!response.ok) {
        const errorData = await response.json()
        if (response.status === 400) {
          toast.error(errorData.error || "Bad Request: Invalid data submitted.")
        } else {
          toast.error(`Error ${response.status}: ${errorData.message || "Something went wrong."}`)
        }
        return
      }

      const responseData = await response.json()
      await getMeritListApplications(currentMeritListId)
      toast.success(responseData.success || "Program adjusted successfully")
      handleCloseProgramAdjustDialog()
    } catch (error) {
      console.error("Program adjustment failed:", error)
      toast.error("Network error or server unreachable.")
    } finally {
      setAdjustmentLoading(false)
    }
  }

  // Enhanced validation for update form
  const validateUpdate = () => {
    const errors = {}
    if (!updateName.trim()) {
      errors.name = "Name is required"
    } else if (updateName.trim().length < 3) {
      errors.name = "Name must be at least 3 characters long"
    }

    if (!updateLastDate) {
      errors.lastDate = "Last Date is required"
    } else {
      const selectedDate = new Date(updateLastDate)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      if (selectedDate < today) {
        errors.lastDate = "Last Date cannot be in the past"
      }
    }

    return errors
  }

  // Add update API call with loading
  const handleUpdateMeritList = async () => {
    const errors = validateUpdate()
    if (Object.keys(errors).length > 0) {
      setUpdateErrors(errors)
      return
    }

    setUpdateLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/update_merit_list/${updateMeritListId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: updateName,
          last_date: updateLastDate,
        }),
      })

      const data = await response.json()
      if (response.ok) {
        toast.success(data.success || "Merit List updated successfully")
        handleGetMeritLists()
        handleCloseUpdateDialog()
      } else {
        toast.error(data.error || "Failed to update merit list")
      }
    } catch (error) {
      console.error("Error updating merit list:", error)
      toast.error("Failed to update merit list")
    } finally {
      setUpdateLoading(false)
    }
  }

  const handleOpenEditDialog = (application_form_id, merit_list_application_id, merit_list_id) => {
    setMeritListApplication(merit_list_application_id)
    setApplicationForm(application_form_id)
    setMeritList(merit_list_id)
    getApplication(application_form_id)
    setOpenEditDialog(true)
  }

  const handleAcademicChange = (index, field, value) => {
    const updatedAcademics = [...academics]
    updatedAcademics[index][field] = value
    setAcademics(updatedAcademics)
  }

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

const debouncedSearchQuery = useDebounce(searchQuery, 300)

  // const filteredApplications = useMemo(() => {
  //   if (!debouncedSearchQuery || debouncedSearchQuery.trim() === "") {
  //     return meritListApplications
  //   }

  //   const query = debouncedSearchQuery.toLowerCase().trim()
  //   return meritListApplications.filter(
  //     (item) =>
  //       item.application_form?.toString().toLowerCase().includes(query) ||
  //       item.first_name?.toLowerCase().includes(query) ||
  //       item.cnic?.toString().toLowerCase().includes(query) ||
  //       item.father_name?.toLowerCase().includes(query),
  //   )
  // }, [meritListApplications, debouncedSearchQuery])
useEffect(() => {
  if (currentMeritListId && openViewDialog) {
    setCurrentPage(1) // Reset to first page when searching
    getMeritListApplications(currentMeritListId, 1, debouncedSearchQuery)
  }
}, [debouncedSearchQuery])
// Pagination handlers
const handlePageChange = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
    getMeritListApplications(currentMeritListId, newPage, debouncedSearchQuery)
  }
}

const handlePrevious = () => {
  if (hasPrevious) {
    handlePageChange(currentPage - 1)
  }
}

const handleNext = () => {
  if (hasNext) {
    handlePageChange(currentPage + 1)
  }
}
  const getApplication = async (application_id) => {
    try {
      const response = await fetch(`${BASE_URL}/submit_application/get_application/${application_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const jsonData = await response.json()
      if (jsonData.academics.length > 0) {
        const processedAcademics = jsonData.academics.map((incomingAcademic) => {
          const academicObject = {}
          const currentType = incomingAcademic.type
          const existingAcademic = academics.find((item) => item.type === currentType)

          Object.keys(incomingAcademic).forEach((key) => {
            academicObject[key] = incomingAcademic[key]
          })

          return academicObject
        })
        setAcademics(processedAcademics)
      }
    } catch (error) {
      console.error(error.message)
      toast.error("Failed to load application data")
    }
  }

  const handleDelete = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }

    try {
      const response = await fetch(`${BASE_URL}/application/delete_merit_list/${currentId}`, requestOptions)
      const data = await response.json()

      if (response.ok) {
        toast.success("Merit List deleted successfully")
        handleCloseDeleteDialog()
        handleGetMeritLists()
      } else {
        toast.error(data.error || "Failed to delete merit list")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to delete merit list")
    }
  }

  // Updated getMeritListApplications function with loading state
const getMeritListApplications = async (id, page = 1, search = "") => {
  if (page === 1) {
    setViewApplicationsLoading(true)
  } else {
    setPaginationLoading(true)
  }
  
  setCurrentViewingMeritId(id)
  
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page: page.toString()
    })
    
    if (search && search.trim() !== "") {
      params.append('search', search.trim())
    }
    
    const response = await fetch(`${BASE_URL}/application/get_merit_list_applications/${id}?${params}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    const data = await response.json()
    if (response.ok) {
      setMeritListApplications(data.merit_list_applications)
      
      // Set pagination data
      setCurrentPage(data.pagination.current_page)
      setTotalPages(data.pagination.total_pages)
      setTotalItems(data.pagination.total_items)
      setHasNext(data.pagination.has_next)
      setHasPrevious(data.pagination.has_previous)
      
      setCurrentMeritListId(id)
      
      // Only open dialog on first load
      if (page === 1) {
        setOpenViewDialog(true)
      }
    } else {
      toast.error(data.error || "Failed to fetch applications")
    }
  } catch (error) {
    console.error(error)
    toast.error("Failed to fetch applications")
  } finally {
    setViewApplicationsLoading(false)
    setPaginationLoading(false)
    setCurrentViewingMeritId("")
  }
};

  const getAllCampaigns = async () => {
    setCampaignsLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/campaign/get_campaigns`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()
      if (response.ok) {
        setCampaigns(data.campaigns)
      } else {
        toast.error(data.error || "Failed to fetch campaigns")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch campaigns")
    } finally {
      setCampaignsLoading(false)
    }
  }

  const handleOpenVoucherModal = async (id) => {
    setVoucherLoading(true)
    try {
      const voucher = await generateVoucher(id)
      setAdmissionVoucher(voucher)
      setVoucherModal(true)
    } catch (error) {
      console.error("Error generating voucher:", error)
      toast.error("Error generating voucher")
    } finally {
      setVoucherLoading(false)
    }
  }

  const generateVoucher = async (id) => {
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/generate_application_voucher_v2/${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`)
      }

      const data = await response.json()
      return data.admission_voucher
    } catch (error) {
      console.error("Error generating voucher:", error)
      throw error
    }
  }

  const getDepartments = async () => {
    setDepartmentsLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/department/get_departments`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()
      if (response.ok) {
        setDepartments(data.departments)
      } else {
        toast.error(data.error || "Failed to fetch departments")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch departments")
    } finally {
      setDepartmentsLoading(false)
    }
  }

  const getTemplates = async () => {
    try {
      const response = await fetch(`${BASE_URL}/application/get_merit_list_templates`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()
      if (response.ok) {
        setMeritListsTemplates(data.templates)
      } else {
        toast.error(data.error || "Failed to fetch templates")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch templates")
    }
  }

  const getDegreesByDepartments = async (department_id) => {
    setProgramsLoading(true)
    try {
      const response = await fetch(
        `${BASE_URL}/degree/get_grouped_degrees_by_department/${department_id}?campaign_id=${selectedCampaign}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )

      const data = await response.json()
      if (response.ok) {
        setPrograms(data.grouped_degrees)
        setGroupedDegrees(data.grouped_degrees)
      } else {
        toast.error(data.error || "Failed to fetch programs")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch programs")
    } finally {
      setProgramsLoading(false)
    }
  }

  function getSessionsByPrograms(programIds) {
    if (!Array.isArray(programIds) || programIds.length === 0) {
      return []
    }

    const allSessions = groupedDegrees.flatMap((group) => group.sessions)
    const matchingSessions = allSessions.filter((session) => programIds.includes(session.program_id))

    return matchingSessions.map((session) => ({
      id: `${session.program_id}_${session.session}`,
      name: session.session.charAt(0).toUpperCase() + session.session.slice(1).toLowerCase(),
    }))
  }

  const getQuotas = async () => {
    setQuotasLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/quota/get_quotas`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()
      if (response.ok) {
        setQuotas(data.quotas)
      } else {
        toast.error(data.error || "Failed to fetch quotas")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch quotas")
    } finally {
      setQuotasLoading(false)
    }
  }

  const handleCampaignChange = (event) => {
    setSelectedCampaign(event.target.value)
  }

  const handleDepartementChange = (event) => {
    setSelectedDepartment(event.target.value)
    if (event.target.value) {
      getDegreesByDepartments(event.target.value)
    }
  }

  const handleProgramChange = (event) => {
    setSelectedProgram(event.target.value)
  }

  const getPreviousPrograms = async () => {
    try {
      const response = await fetch(`${BASE_URL}/submit_application/get_previous_programs`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const result = await response.json()
      if (result.previous_programs) {
        setPreviousPrograms(result.previous_programs)
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch previous programs")
    }
  }

  const getUniversities = async () => {
    try {
      const response = await fetch(`${BASE_URL}/submit_application/get_previous_universities`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const result = await response.json()
      if (result.previous_universities) {
        setUniversities(result.previous_universities)
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch universities")
    }
  }

  const getSubjects = async () => {
    try {
      const response = await fetch(`${BASE_URL}/submit_application/get_previous_subjects`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const result = await response.json()
      if (result.previous_subjects) {
        setSubjects(result.previous_subjects)
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch subjects")
    }
  }

  const handleSaveAcademics = async () => {
    const data = {
      application_id: applicationForm,
      merit_list_application_id: meritListApplication,
      academics: academics,
    }

    try {
      const response = await fetch(`${BASE_URL}/submit_application/edit_academics_admin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      })

      const result = await response.json()
      if (result.success) {
        toast.success(result.success)
        getMeritListApplications(meritList)
        handleCloseEditDialog()
      } else {
        toast.error(result.message || "Failed to save academics")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to save academics")
    }
  }

  // Enhanced validation for merit list creation
  const validate = () => {
    const errors = {}
    if (!name.trim()) {
      errors.name = "Name is required"
    } else if (name.trim().length < 3) {
      errors.name = "Name must be at least 3 characters long"
    }

    if (!lastDate) {
      errors.lastDate = "Last Date is required"
    } else {
      const selectedDate = new Date(lastDate)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      if (selectedDate < today) {
        errors.lastDate = "Last Date cannot be in the past"
      }
    }

    if (!selectedCampaign) {
      errors.campaign = "Campaign is required"
    }

    if (!selectedDepartment) {
      errors.department = "Department is required"
    }

    if (!selectedProgram) {
      errors.program = "Program is required"
    }

    if (!selectedQuota) {
      errors.quota = "Quota is required"
    }

    if (!selectedMeritListType) {
      errors.meritListType = "Merit List Type is required"
    }

    if (!selectedTemplate) {
      errors.templates = "Template is required"
    }

    if (!multiplier || multiplier <= 0) {
      errors.multiplier = "Multiplier must be greater than 0"
    }

    if (!wantToInclude) {
      errors.wantToInclude = "Want to Include is required"
    }

    return errors
  }

  const handleGenerateMeritList = async () => {
    const errors = validate()
    if (Object.keys(errors).length > 0) {
      setErrors(errors)
      toast.error("Please fix all validation errors")
      return
    }

    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/generate_merit_list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          campaign_id: selectedCampaign,
          department_id: selectedDepartment,
          program_ids: selectedProgram,
          merit_list_type: selectedMeritListType,
          program_criteria_id: programCriteriaId,
          template_id: selectedTemplate,
          quota_id: selectedQuota,
          multiplier: multiplier,
          want_to_include: wantToInclude, // Add the new field
        }),
      })

      const data = await response.json()
      if (response.ok && data.merit_list) {
        setGeneratedMeritList(data.merit_list)
        toast.success("Merit list generated successfully")
      } else if (data.error && String(data.error).toLowerCase().includes("vacant")) {
        setGeneratedMeritList([])
        toast.error(data.error || "There are no vacant seats")
      } else {
        setGeneratedMeritList([])
        toast.error(data.error || "Failed to generate merit list")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to generate merit list")
    } finally {
      setLoading(false)
    }
  }

  const handleSave = async () => {
    const errors = validate()
    if (Object.keys(errors).length > 0) {
      setErrors(errors)
      return
    }

    if (generatedMeritList.length === 0) {
      toast.error("Please generate merit list first")
      return
    }

    setSaveLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/add_merit_list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name,
          last_date: lastDate,
          campaign_id: selectedCampaign,
          department_id: selectedDepartment,
          program_ids: selectedProgram,
          merit_list_type: selectedMeritListType,
          program_criteria_id: programCriteriaId,
          quota_id: selectedQuota,
          template_id: selectedTemplate,
          multiplier: multiplier,
          want_to_include: wantToInclude, // Add the new field
          merit_list_applications: generatedMeritList,
        }),
      })

      const data = await response.json()
      if (response.ok) {
        toast.success(data.success || "Merit list saved successfully")
        handleGetMeritLists()
        handleCloseDialog()
      } else {
        toast.error(data.error || "Failed to save merit list")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to save merit list")
    } finally {
      setSaveLoading(false)
    }
  }

  const handleGetMeritLists = async () => {
    if (!selectedCampaign) {
      toast.error("Please select a campaign first")
      return
    }

    setMeritListsLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/get_filerted_merit_list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          campaign_id: selectedCampaign,
          department_id: selectedDepartment,
          program_id: selectedProgram,
          quota_id: selectedQuota,
        }),
      })

      const data = await response.json()
      if (response.ok) {
        setMeritLists(data.merit_lists)
      } else {
        toast.error(data.error || "Failed to fetch merit lists")
      }
    } catch (error) {
      console.error(error)
      toast.error("Failed to fetch merit lists")
    } finally {
      setMeritListsLoading(false)
    }
  }

  const handleVerify = async (application_form_id, merit_list_application_id, merit_list_id) => {
    setMeritListApplication(merit_list_application_id)
    setVerifyLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/verify_documents`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          application_form_id,
          merit_list_application_id,
        }),
      })

      if (!response.ok) {
        const errorData = await response.json()
        if (response.status === 400) {
          toast.error(errorData.error || "Bad Request: Invalid data submitted.")
        } else {
          toast.error(`Error ${response.status}: ${errorData.message || "Something went wrong."}`)
        }
        return
      }

      const responseData = await response.json()
      await getMeritListApplications(merit_list_id)
      toast.success(responseData.success || "Documents verified successfully")
    } catch (error) {
      console.error("Fetch failed:", error)
      toast.error("Network error or server unreachable.")
    } finally {
      setVerifyLoading(false)
    }
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setName("")
    setLastDate("")
    setSelectedCampaign("")
    setSelectedDepartment("")
    setSelectedProgram("")
    setSelectedQuota("")
    setSelectedMeritListType("")
    setSelectedTemplate("")
    setMultiplier(1)
    setWantToInclude("both") // Reset to default
    setGeneratedMeritList([])
    setErrors({})
  }

  const handleApprove = async (merit_list_id) => {
    setApproveLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/approve_merit_list/${merit_list_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = await response.json()
      if (response.ok) {
        toast.success(data.success || "Merit list approved successfully")
        handleGetMeritLists()
      } else {
        toast.error(data.error || "Failed to approve merit list")
      }
    } catch (error) {
      console.error("Error approving merit list:", error)
      toast.error("Failed to approve merit list")
    } finally {
      setApproveLoading(false)
    }
  }

  const handleSendWhatsapp = async (merit_list_id) => {
    setWhatsappLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/send_whatsapp_message_to_merit_list_applicants`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ merit_list_id }),
      })

      const data = await response.json()
      if (response.ok) {
        toast.success(data.status || "Messages are being sent.")
      } else {
        toast.error(data.error || "Failed to send WhatsApp messages.")
      }
    } catch (error) {
      console.error("Network or server error:", error)
      toast.error("Something went wrong while sending WhatsApp messages.")
    } finally {
      setWhatsappLoading(false)
    }
  }
  const handleSendSMS = async (merit_list_id) => {
    setWhatsappLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/application/send_sms_to_merit_list_applicants`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ merit_list_id }),
      })

      const data = await response.json()
      if (response.ok) {
        toast.success(data.status || "Messages are being sent.")
      } else {
        toast.error(data.error || "Failed to send WhatsApp messages.")
      }
    } catch (error) {
      console.error("Network or server error:", error)
      toast.error("Something went wrong while sending WhatsApp messages.")
    } finally {
      setWhatsappLoading(false)
    }
  }
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Program ", accessor: "program", align: "center" },
    { Header: "Quota", accessor: "quota", align: "center" },
    { Header: "Last Date", accessor: "last_date", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ]

  const rows =
    meritLists.length > 0
      ? meritLists.map((merit, index) => {
          return {
            serial: index + 1,
            name: merit.name,
            program: merit.program_name,
            quota: merit.quota_name,
            last_date: merit.last_date,
            actions: (
              <>
                {hasAdmissionPermission("Merit Lists", "UPDATE") && (
                  <Tooltip title="Update Merit List">
                    <IconButton onClick={() => handleOpenUpdateDialog(merit.id, merit.name, merit.last_date)}>
                      <EditIcon className="icon-button-edit" />
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Merit Lists", "DELETE") && (
                  <Tooltip title="Delete Merit List">
                    <IconButton
                      onClick={() => {
                        setOpenDeleteDialog(true)
                        setCurrentId(merit.id)
                      }}
                    >
                      <DeleteIcon className="icon-button-delete" />
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Merit Lists", "READ") && (
                  <Tooltip title="View Merit List Pdf">
                    <IconButton
                      onClick={() => {
                        window.open(`${BASE_URL}/application/view_merit_list/${merit.url_token}`)
                      }}
                    >
                      <PreviewIcon className="icon-button-view" />
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Merit Lists", "MANAGE") && (
                  <Tooltip title="View & Verify Documents">
                    <IconButton
                      onClick={() => {
                        setCurrentMeritUrlToken(merit.url_token || "")
                        setCurrentViewingMeritName(merit.name || "")
                        getMeritListApplications(merit.id)
                      }}
                      disabled={viewApplicationsLoading && currentViewingMeritId === merit.id}
                    >
                      {viewApplicationsLoading && currentViewingMeritId === merit.id ? (
                        <CircularProgress size={20} />
                      ) : (
                        <PolicyIcon className="icon-button-edit" />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
                {merit.is_approve !== 1 && hasAdmissionPermission("Merit Lists", "APPROVE") && (
                  <Tooltip title="Approve Merit List">
                    <IconButton onClick={() => handleApprove(merit.id)} disabled={approveLoading}>
                      {approveLoading ? <CircularProgress size={20} /> : <DoneIcon className="icon-button-approve" />}
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Merit Lists", "APPROVE") && (
                  <Tooltip title="Send Whatsapp Merit List">
                    <IconButton onClick={() => handleSendWhatsapp(merit.id)} disabled={whatsappLoading}>
                      {whatsappLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <ForwardToInboxIcon className="icon-button-edit" />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
                 {hasAdmissionPermission("Merit Lists", "APPROVE") && (
                  <Tooltip title="Send SMS Merit List">
                    <IconButton onClick={() => handleSendSMS(merit.id)} disabled={whatsappLoading}>
                      {whatsappLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <SendIcon className="icon-button-edit" />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
              </>
            ),
          }
        })
      : []

  useEffect(() => {
    getAllCampaigns()
    getDepartments()
    getTemplates()
    getQuotas()
    getPreviousPrograms()
    getUniversities()
    getSubjects()
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <div className="row">
              <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} paddingRight={3}>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="campaign">Campaign</label>
                    <Select
                      id="campaign"
                      options={campaigns}
                      getOptionLabel={(e) => e.name}
                      getOptionValue={(e) => e.id}
                      value={campaigns.find((c) => c.id === selectedCampaign)}
                      onChange={(option) => setSelectedCampaign(option?.id)}
                      isSearchable
                      isLoading={campaignsLoading}
                      placeholder="Select Campaign"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="department">Department</label>
                    <Select
                      id="department"
                      options={departments}
                      getOptionLabel={(dept) => dept.name}
                      getOptionValue={(dept) => dept.id}
                      value={departments.find((d) => d.id === selectedDepartment)}
                      onChange={(option) => handleDepartementChange({ target: { value: option?.id } })}
                      isSearchable
                      isLoading={departmentsLoading}
                      placeholder="Select Department"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="program">Program</label>
                    <Select
                      id="program"
                      options={programs}
                      getOptionLabel={(program) => program.name}
                      getOptionValue={(program) => program.id}
                      value={programs.find((p) => p.id === selectedProgram)}
                      onChange={(option) => handleProgramChange({ target: { value: option?.id } })}
                      isSearchable
                      isLoading={programsLoading}
                      placeholder="Select Program"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="quota">Quota</label>
                    <Select
                      id="quota"
                      options={quotas}
                      getOptionLabel={(quota) => quota.name}
                      getOptionValue={(quota) => quota.id}
                      value={quotas.find((q) => q.id === selectedQuota)}
                      onChange={(option) => setSelectedQuota(option?.id)}
                      isSearchable
                      isLoading={quotasLoading}
                      placeholder="Select Quota"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
              </Stack>
              <div className="col-md-9"></div>
              <div className="col-md-3 mt-3 d-flex justify-content-end">
                <Button
                  variant="outlined"
                  onClick={handleGetMeritLists}
                  className="add-full-button"
                  disabled={meritListsLoading}
                >
                  {meritListsLoading ? <CircularProgress size={20} /> : "Get Merit Lists"}
                </Button>
              </div>
            </div>
            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                {hasAdmissionPermission("Merit Lists", "CREATE") && (
                  <Button
                    variant="outlined"
                    endIcon={<AddIcon className="add-icon" />}
                    onClick={handleOpenDialog}
                    className="add-full-button"
                  >
                    Make Merit List
                  </Button>
                )}
              </MDBox>
              <MDBox pt={3}>
                {meritLists && meritLists.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata || "/placeholder.svg"}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Create Merit List Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          Create Merit List
        </DialogTitle>
        <DialogContent className="dialog-content-critera" style={{ height: "100%", minHeight: "300px" }}>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="name">Enter Merit List Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Merit List Name"
                />
                {errors.name && <div className="text-danger">{errors.name}</div>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="lastDate">Last Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="lastDate"
                  value={lastDate}
                  onChange={(e) => setLastDate(e.target.value)}
                />
                {errors.lastDate && <div className="text-danger">{errors.lastDate}</div>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="template">Template</label>
                <Select
                  id="template"
                  options={merit_lists_templates}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e.id}
                  value={merit_lists_templates.find((c) => c.id === selectedTemplate)}
                  onChange={(option) => setSelectedTemplate(option?.id)}
                  isSearchable
                  placeholder="Select Template"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
                {errors.templates && <div className="text-danger">{errors.templates}</div>}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group">
                <label htmlFor="campaign">Campaign</label>
                <Select
                  id="campaign"
                  options={campaigns}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e.id}
                  value={campaigns.find((c) => c.id === selectedCampaign)}
                  onChange={(option) => setSelectedCampaign(option?.id)}
                  isSearchable
                  placeholder="Select Campaign"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
                {errors.campaign && <div className="text-danger">{errors.campaign}</div>}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group">
                <label htmlFor="department">Department</label>
                <Select
                  id="department"
                  options={departments}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e.id}
                  value={departments.find((d) => d.id === selectedDepartment)}
                  onChange={(option) => {
                    const departmentId = option?.id
                    setSelectedDepartment(departmentId)
                    if (departmentId) {
                      getDegreesByDepartments(departmentId)
                    }
                  }}
                  isSearchable
                  placeholder="Select Department"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
                {errors.department && <div className="text-danger">{errors.department}</div>}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group">
                <label htmlFor="program">Program</label>
                <Select
                  id="program"
                  options={programs}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e.id}
                  value={programs.find((p) => p.id === selectedProgram)}
                  onChange={(option) => {
                    const programId = option?.id || null
                    setSelectedProgram(programId)
                    const selectedProgramObj = programs.find((p) => p.id === programId)
                    const sessions = selectedProgramObj?.sessions || []
                    setMeritListTypes(sessions)
                  }}
                  isSearchable
                  placeholder="Select Program"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
                {errors.program && <div className="text-danger">{errors.program}</div>}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group">
                <label htmlFor="quota">Quota</label>
                <Select
                  id="quota"
                  options={quotas}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e.id}
                  value={quotas.find((q) => q.id === selectedQuota)}
                  onChange={(option) => setSelectedQuota(option?.id)}
                  isSearchable
                  placeholder="Select Quota"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
                {errors.quota && <div className="text-danger">{errors.quota}</div>}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group">
                <label htmlFor="meritListType">Merit List Type</label>
                <Select
                  id="meritListType"
                  options={meritListTypes}
                  getOptionLabel={(e) => e.session}
                  getOptionValue={(e) => e.session}
                  value={meritListTypes.find((m) => m.session === selectedMeritListType)}
                  onChange={(option) => {
                    setSelectedMeritListType(option?.session)
                    setProgramCriteriaId(option?.program_id)
                  }}
                  isSearchable
                  placeholder="Select Merit List Type"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
                {errors.meritListType && <div className="text-danger">{errors.meritListType}</div>}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group">
                <label htmlFor="multiplier">Multiplier</label>
                <input
                  name="multiplier"
                  type="number"
                  min="0.1"
                  step="0.1"
                  value={multiplier}
                  onChange={(e) => setMultiplier(Number.parseFloat(e.target.value) || 1)}
                  className="form-control form-control-lg"
                  placeholder="Enter Multiplier"
                />
                {errors.multiplier && <div className="text-danger">{errors.multiplier}</div>}
              </div>
            </div>
            {/* Add the new Want to Include field */}
            <div className="col-md-6 mt-3">
              <FormControl component="fieldset">
                <FormLabel component="legend" style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}>
                  Want to Include
                </FormLabel>
                <RadioGroup
                  row
                  aria-label="want-to-include"
                  name="wantToInclude"
                  value={wantToInclude}
                  onChange={(e) => setWantToInclude(e.target.value)}
                  style={{ marginTop: "8px" }}
                >
                  <FormControlLabel
                    value="both"
                    control={<Radio size="small" />}
                    label="Both"
                    style={{ marginRight: "20px" }}
                  />
                  <FormControlLabel
                    value="selected"
                    control={<Radio size="small" />}
                    label="Selected Merit List Type"
                    style={{ marginRight: "20px" }}
                  />
                </RadioGroup>
                {errors.wantToInclude && (
                  <div className="text-danger" style={{ fontSize: "12px", marginTop: "4px" }}>
                    {errors.wantToInclude}
                  </div>
                )}
              </FormControl>
            </div>
          </div>

          {loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "20px 0",
              }}
            >
              <CircularProgress />
              <Typography variant="body2" style={{ marginLeft: "10px" }}>
                Generating merit list...
              </Typography>
            </div>
          )}

          {generatedMeritList.length > 0 && (
            <div className="row mt-3">
              <div className="col-md-12 mb-3">
                <Typography variant="h5">Generated Merit List ({generatedMeritList.length} applications)</Typography>
              </div>
              <div className="col-md-12">
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <table className="table table-bordered">
                    <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
                      <tr>
                        <th>Sr.No</th>
                        <th>Application ID</th>
                        <th>Name</th>
                        <th>CNIC</th>
                        <th>Father Name</th>
                        <th>Aggregate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {generatedMeritList.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.application_form_id}</td>
                          <td>{item.name}</td>
                          <td>{item.cnic}</td>
                          <td>{item.father_name}</td>
                          <td>{item.aggregate.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            className="dialog-actions-button negative"
            disabled={loading || saveLoading}
          >
            Cancel
          </Button>
          {generatedMeritList.length <= 0 && (
            <Button className="dialog-actions-button positive" onClick={handleGenerateMeritList} disabled={loading}>
              {loading ? <CircularProgress size={20} /> : "Generate"}
            </Button>
          )}
          {generatedMeritList.length > 0 && (
            <Button className="dialog-actions-button positive" onClick={handleSave} disabled={saveLoading}>
              {saveLoading ? <CircularProgress size={20} /> : "Save"}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* All other existing dialogs remain the same... */}
      {/* Merit List Application Delete Dialog */}
      <Dialog
        open={openDeleteApplicationDialog}
        onClose={handleCloseDeleteApplicationDialog}
        aria-labelledby="delete-application-dialog-title"
        aria-describedby="delete-application-dialog-description"
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle id="delete-application-dialog-title" className="dialog-delete">
          Confirm Application Deletion
        </DialogTitle>
        <DialogContent id="delete-application-dialog-description" className="content-delete">
          Are you sure you want to delete the application for <strong>{currentApplicationName}</strong>? This action
          cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDeleteApplicationDialog}
            className="dialog-actions-button negative"
            disabled={deleteApplicationLoading}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleDeleteApplication}
            disabled={deleteApplicationLoading}
          >
            {deleteApplicationLoading ? <CircularProgress size={20} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Program Adjustment Dialog */}
      <Dialog
        open={openProgramAdjustDialog}
        onClose={handleCloseProgramAdjustDialog}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="program-adjust-dialog-title" className="dialog-title">
          Program Adjustment
        </DialogTitle>
        <DialogContent className="dialog-content-critera">
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Select the program to move this applicant into. Evening programs are available to all
            authorized users. Morning programs are only shown for Super Admin and BZU roles.
          </Typography>
          <div className="row">
            <div className="col-md-12 mt-3">
              <div className="form-group">
                <label htmlFor="adjustmentProgram">Select Program</label>
                <Select
                  id="adjustmentProgram"
                  options={adjustmentPrograms}
                  getOptionLabel={formatAdjustmentProgramLabel}
                  getOptionValue={(program) => program.id}
                  value={adjustmentPrograms.find((p) => p.id === selectedAdjustmentProgram)}
                  onChange={(option) => setSelectedAdjustmentProgram(option?.id)}
                  isSearchable
                  placeholder="Select Program"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
                {adjustmentErrors.program && <div className="text-danger">{adjustmentErrors.program}</div>}
                {!canAdjustMorning && (
                  <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
                    Morning programs are not available for your role.
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseProgramAdjustDialog}
            className="dialog-actions-button negative"
            disabled={adjustmentLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleProgramAdjustment}
            className="dialog-actions-button positive"
            disabled={adjustmentLoading}
          >
            {adjustmentLoading ? <CircularProgress size={20} /> : "Adjust"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Dialog */}
      <Dialog
        open={openUpdateDialog}
        onClose={handleCloseUpdateDialog}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="update-dialog-title" className="dialog-title">
          Update Merit List
        </DialogTitle>
        <DialogContent className="dialog-content-critera">
          <div className="row">
            <div className="col-md-12 mt-3">
              <div className="form-group">
                <label htmlFor="updateName">Merit List Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="updateName"
                  value={updateName}
                  onChange={(e) => setUpdateName(e.target.value)}
                  placeholder="Enter Merit List Name"
                />
                {updateErrors.name && <div className="text-danger">{updateErrors.name}</div>}
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <div className="form-group">
                <label htmlFor="updateLastDate">Last Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="updateLastDate"
                  value={updateLastDate}
                  onChange={(e) => setUpdateLastDate(e.target.value)}
                />
                {updateErrors.lastDate && <div className="text-danger">{updateErrors.lastDate}</div>}
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUpdateDialog} className="dialog-actions-button negative" disabled={updateLoading}>
            Cancel
          </Button>
          <Button onClick={handleUpdateMeritList} className="dialog-actions-button positive" disabled={updateLoading}>
            {updateLoading ? <CircularProgress size={20} /> : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Merit List Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle id="alert-dialog-title" className="dialog-delete">
          Confirm Deletion
        </DialogTitle>
        <DialogContent id="alert-dialog-description" className="content-delete">
          Are you sure you want to delete this merit list?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} className="dialog-actions-button negative">
            Cancel
          </Button>
          <Button className="dialog-actions-button positive" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Merit List Applications Dialog */}
<Dialog
  open={openViewDialog}
  onClose={handleCloseViewDialog}
  fullWidth
  maxWidth="xxl"
  PaperProps={{
    className: "dialog-paper",
  }}
>
  <DialogTitle id="responsive-dialog-title" className="dialog-delete">
    View Merit List & Verify Documents
  </DialogTitle>
  <DialogContent className="content-delete mt-4">
    <div className="row align-items-center">
      <div className="col-md-8 mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search by Form No, Name, CNIC"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className="col-md-4 mb-3 text-md-end">
        <Button
          variant="contained"
          color="info"
          startIcon={exportPdfLoading ? <CircularProgress size={16} /> : <FileDownloadIcon />}
          onClick={handleExportMeritListPdf}
          disabled={!currentMeritListId || exportPdfLoading}
          style={{ color: "black" }}
        >
          {exportPdfLoading ? "Exporting..." : "Export PDF"}
        </Button>
      </div>
    </div>
    
    {/* Results summary */}
    {totalItems > 0 && (
      <div className="row mb-2">
        <div className="col-md-12">
          <small className="text-muted">
            {debouncedSearchQuery && debouncedSearchQuery.trim() !== "" 
              ? `Showing ${meritListApplications.length} of ${totalItems} applications matching ${debouncedSearchQuery}`
              : `Showing ${meritListApplications.length} of ${totalItems} applications`
            }
            {totalPages > 1 && ` (Page ${currentPage} of ${totalPages})`}
          </small>
        </div>
      </div>
    )}
    
    {/* Loading indicator for pagination */}
    {paginationLoading && (
      <div className="row mb-3">
        <div className="col-md-12 text-center">
          <CircularProgress size={20} />
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    )}
    
    {meritListApplications.length > 0 && (
      <div className="row">
        <div className="col-md-12">
          <div style={{ overflowX: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: "5%", textAlign: "center" }}>Sr.No</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Form No</th>
                  <th style={{ width: "10%", textAlign: "center" }}>Name</th>
                  <th style={{ width: "12%", textAlign: "center" }}>CNIC</th>
                  <th style={{ width: "10%", textAlign: "center" }}>Phone</th>
                  <th style={{ width: "10%", textAlign: "center" }}>Father Name</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Aggregate</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Status</th>
                  <th style={{ width: "8%", textAlign: "center" }}>View</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Verify</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Program Adjustment</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Processing Voucher</th>
                  <th style={{ width: "7%", textAlign: "center" }}>Delete</th>
                </tr>
              </thead>
              <tbody>
                {meritListApplications.map((item, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>
                      {(currentPage - 1) * 100 + index + 1}
                    </td>
                    <td style={{ textAlign: "center" }}>{item.application_form}</td>
                    <td style={{ textAlign: "center" }}>{item.first_name}</td>
                    <td style={{ textAlign: "center" }}>{item.cnic}</td>
                    <td style={{ textAlign: "center" }}>{item.applicant_phone}</td>
                    <td style={{ textAlign: "center" }}>{item.father_name}</td>
                    <td style={{ textAlign: "center" }}>{Number(item.aggregrate).toFixed(2)}</td>
                    <td style={{ textAlign: "center" }}>{item.is_verified == 1 ? "Verified" : "Not Verified"}</td>
                    <td style={{ textAlign: "center" }}>
                      <Button
                        size="small"
                        onClick={() => {
                          window.open(`/admissions/get-applications/${item.application_form}`)
                        }}
                      >
                        View Application
                      </Button>
                      <Button
                        size="small"
                        onClick={() => {
                          window.open(`/admissions/view-admission-form/${item.application_form}`)
                        }}
                      >
                        View Form
                      </Button>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item && item.is_verified === 0 ? (
                        <>
                          {verifyLoading && meritListApplication == item.id ? (
                            <CircularProgress size="20px" />
                          ) : (
                            <Button
                              size="small"
                              onClick={() => handleVerify(item.application_form, item.id, item.merit_list)}
                            >
                              Verify Documents
                            </Button>
                          )}
                        </>
                      ) : (
                        <Button
                          size="small"
                          onClick={() => {
                            window.open(`/admissions/fee-voucher/${item.voucher_url_token}`)
                          }}
                        >
                          View Voucher
                        </Button>
                      )}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.is_verified == 0 ? (
                        <Button
                          size="small"
                          onClick={() => handleOpenProgramAdjustDialog(item.id, item.merit_list)}
                        >
                          Program Adjustment
                        </Button>
                      ) : (
                        <>N/A</>
                      )}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.is_paid == 0 ? (
                        <Button
                          size="small"
                          onClick={() => handleOpenVoucherModal(item.application_form)}
                          disabled={voucherLoading}
                        >
                          {voucherLoading ? <CircularProgress size={16} /> : "Print Processing Voucher"}
                        </Button>
                      ) : (
                        <>Paid</>
                      )}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item && item.is_verified === 0 && (
                        <Tooltip title="Delete Application">
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDeleteApplicationDialog(item.id, item.first_name)}
                            color="error"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )}
    
    {/* Pagination Controls */}
    {totalPages > 1 && (
      <div className="row mt-3">
        <div className="col-md-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <small className="text-muted">
                Page {currentPage} of {totalPages} ({totalItems} total items)
              </small>
            </div>
            <div className="d-flex align-items-center gap-2">
              <Button
                size="small"
                onClick={handlePrevious}
                disabled={!hasPrevious || paginationLoading}
                variant="contained"
                color="primary"
                style={{color: 'white'}}
              >
                Previous
              </Button>
              
              <span className="mx-2">
                Page {currentPage} of {totalPages}
              </span>
              
              <Button
                size="small"
                onClick={handleNext}
                disabled={!hasNext || paginationLoading}
                variant="contained"
                color="primary"
                style={{color: 'white'}}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
    )}
    
    {/* No results message */}
    {!viewApplicationsLoading && meritListApplications.length === 0 && (
      <div className="row">
        <div className="col-md-12 text-center">
          <p className="text-muted">
            {debouncedSearchQuery && debouncedSearchQuery.trim() !== ""
              ? `No applications found matching ${debouncedSearchQuery}`
              : "No applications found"
            }
          </p>
        </div>
      </div>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseViewDialog} className="dialog-actions-button negative">
      Close
    </Button>
  </DialogActions>
</Dialog>

      {/* Edit Academics Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={handleCloseEditDialog}
        fullWidth
        maxWidth="xl"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          Edit Academics Information{" "}
          <span className="text-danger" style={{ fontSize: "12px" }}>
            Note: Once you edit the academics information, this application will be deleted from Merit List
          </span>
        </DialogTitle>
        <DialogContent className="dialog-content"></DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} className="dialog-actions-button negative">
            Cancel
          </Button>
          <Button onClick={handleSaveAcademics} className="dialog-actions-button positive">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <VoucherDialog
        voucherModal={voucherModal}
        handleCloseVoucherModal={handleCloseVoucherModal}
        admissionVoucher={admissionVoucher}
      />
    </DashboardLayout>
  )
}

export default MeritListV2

